import { Table, Col, Row, Space } from "antd";
import DateTimeStamp from "../misc/DateTimeStamp";
import "./PrintHistoryPage.scss";
import "./PrintOrderPrintableReceipt.scss";
import { OrderDto, ProductDto } from "../../../generated/print-client";
import { Currency } from "../../util/Currency";
import { env } from "../../../env/env";
import { getFriendlyOrderStatus, removeDash } from "../../../util/utils";
// import MhmLogo from "../../icons/MhmLogo";

export interface PrintOrderPrintableReceiptProps {
  order: OrderDto;
}

export function PrintOrderPrintableReceipt({ order }: PrintOrderPrintableReceiptProps) {

  return (
    <div className="print-receipt">

      <link rel="stylesheet" href="./PrintOrderPrintableReceipt.scss" />
      <Row>
        <Col span={10}>
          <h3>Order #{order.number}</h3>
          <Row>
            <Col>
              <b>Status:</b> {getFriendlyOrderStatus(order.status!)}
            </Col>
          </Row>
          <Row>
            <Col>
              <b>Date Placed:</b> <DateTimeStamp date={order.purchaseDate!} />
            </Col>
          </Row>
          <Row>
            <Col>
              <b>Total:</b> ${order.total?.toFixed(2)}
            </Col>
          </Row>
          <Row>
            <Col>
              <b>Payment Method:</b> {order.maskedCard}
            </Col>
          </Row>
        </Col>

        <Col span={10}>
          <Space>
            <h3>Delivery Address</h3>
          </Space>

          <Row>
            <Col><b>Address Type:</b> <span className="cap">{order.addressType}</span></Col>
          </Row>
          <Row>
            <Col>{order.name}</Col>
          </Row>
          <Row>
            <Col>{order.businessName}</Col>
          </Row>
          <Row>
            <Col>{order.addressLine1}</Col>
          </Row>
          <Row>
            <Col>{order.addressLine2}</Col>
          </Row>
          <Row>
            <Col>{order.city}, {order.state}, {order.zip}</Col>
          </Row>
          <Row>
            <Col>{order.phone}</Col>
          </Row>
          <Row>
            <Col>Expected delivery date: {order.edd}</Col>
          </Row>
          <br />
          <Row>
            <Col><b>Shipping Method:</b> Standard Shipping and Processing</Col>
          </Row>
          {order.tracking ?
            <Row>
              <Col><b>Tracking:</b> <a href={"http://wwwapps.ups.com/WebTracking/processInputRequest?tracknum=" + order.tracking} target="_blank" rel="noreferrer">{order.tracking}</a></Col>
            </Row>
            : ''}
        </Col>
      </Row>

      <h3 className="summary-header">Order Summary</h3>
      <Table
        pagination={false}
        columns={[
          {
            title: "Design Name",
            dataIndex: "designId",
            key: "designId",
            render: (designId, item) => (
              <img
                alt={item.designName}
                src={item.thumbs ? env.s3Path + '/' + JSON.parse(item.thumbs)[0].path : `${env.rendererPath}/design/thumbnail/${designId}?height=150`}
              />
            )
          },
          {
            title: "",
            dataIndex: "designName",
            key: "designName",
            render: (designName) => (
              <>
                {designName}
              </>
            ),
          },
          {
            title: "Products",
            dataIndex: "products",
            key: "product",
            render: (products) => (
              <>
                {products.map((product: ProductDto) => {
                  return <>{product.name}<br /></>
                })}
              </>
            ),
          },
          {
            title: "Pages",
            dataIndex: "pages",
            key: "pages",
            align: "center"
          },
          {
            title: "Paper Type",
            dataIndex: "paperType",
            key: "paperType",
            align: "center",
            width: 120,
            render: (paperType) => (
              <span className="cap">{removeDash(paperType)}</span>
            )
          },
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            align: "center"
          },
          {
            title: "Price",
            dataIndex: "price",
            key: "price",
            align: "center",
            render: (price) => (
              <Currency>{price}</Currency>
            ),
          },
        ]}
        dataSource={order.items}
      />

      <Row className="totals">
        <Col span={7} push={17}>
          <Row justify="space-between">
            <Col>Subtotal:</Col>
            <Col><Currency>{order.subtotal}</Currency></Col>
          </Row>

          <Row justify="space-between">
            <Col>Shipping &amp; Processing:</Col>
            <Col><Currency>{order.shipping}</Currency></Col>
          </Row>

          <Row justify="space-between">
            <Col>Tax:</Col>
            <Col><Currency>{order.tax}</Currency></Col>
          </Row>

          <Row justify="space-between" className="total">
            <Col>Total:</Col>
            <Col><Currency>{order.total}</Currency></Col>
          </Row>
        </Col>
      </Row>
      </div>
  );
}
